import constants from '../constants/constants';
import { createVideoAd, createStillAd, createDAAAd } from '../PackageLauncher';

import {
  generateAndGetCanvasUrl,
  createCanvasAdWithCanvasUrl,
  createCanvasForCollectionAd,
  createCollectionAdWithCanvasData,
  createAdCreativeForCarousel,
  createCarouselAdWIthCreative
} from './AdLauncher';

const { LAUNCHER } = constants;
const {
  DAA,
  CANVAS,
  COLLECTION,
  CAROUSEL,
  VIDEO,
  CINEMAGRAPH,
  STILL,
  CONVERSIONS,
  PRODUCT_CATALOG_SALES
} = LAUNCHER;

export const returnInitialLaunchState = (token, cards = null) => {
  const initialLaunchState = {
    token,
    data: null,
    showYearSelector: false,
    showMonthSelector: false,
    selectedYear: '',
    selectedMonth: '',
    showMonthLoader: false,
    showYearLoader: false,
    showAdsetLoader: false,
    selectedCampaigns: '',
    years: [],
    pages: [],
    campaigns: [],
    campaign_ids: [],
    productSets: [],
    processing: false,
    showAdsetsSelector: false,
    log: '',
    selectedPage: '',
    form: {
      status: constants.LAUNCHER.PAUSED,
      accountId: '',
      accountName: '',
      destinationUrl: '',
      footerUrl: '',
      cards: [],
      productSet: '',
      productCatalog: '',
      adsets: [],
      pixel: '',
      pageId: '',
      pageAccessToken: '',
      instagramAccount: '',
      displayUrl: '',
      description: ''
    },
    debugLogOpen: false,
    launchStatus: {},
    currentThumbnail: '',
    thumbnails: []
  };

  if (cards && cards.length > 0) {
    initialLaunchState.form.cards = cards.map((card) => ({
      cardId: card.id,
      destinationUrl: ''
    }));
  }

  return initialLaunchState;
};

export const returnIsAdReadyToLaunch = (adType, form) => {
  const {
    accountId,
    accountName,
    destinationUrl,
    footerUrl,
    cards,
    productSet,
    productCatalog,
    adsets,
    pixel,
    pageId,
    pageAccessToken,
    // instagramAccount,
    displayUrl,
    description
  } = form;
  let adIsReadyToLaunch = false;

  try {
    // to do: dynamically check form fields.
    const validAccountId = accountId && !isNaN(parseInt(accountId, 10));
    const validAccountName = accountName && accountName.trim() !== '';

    const destinationLowerCase = (destinationUrl || '').toLowerCase();
    const destinationUrlHasHttp =
      destinationLowerCase.includes('http://') ||
      destinationLowerCase.includes('https://');

    const validDestinationUrl =
      destinationUrl && destinationUrl.trim() !== '' && destinationUrlHasHttp;

    const validAdsets = adsets && adsets.length > 0;
    const validPixel = pixel && !isNaN(parseInt(pixel, 10));
    const validPageId = pageId && !isNaN(parseInt(pageId, 10));
    const validPageAccessToken =
      pageAccessToken && pageAccessToken.trim() !== '';
    // I am not sure if all accounts require instagram, so I left instagram out.
    // const validInstagramAccount =
    //   instagramAccount && !isNaN(parseInt(instagramAccount, 10));
    let validDisplayUrl = true;
    if (
      adType !== 'Canvas' &&
      adType !== 'Carousel' &&
      adType !== 'Collection'
    ) {
      validDisplayUrl = displayUrl && displayUrl.trim() !== '';
    }

    const cardsWithUrls = cards
      ? cards.filter((card) => {
          const { destinationUrl: cardUrl } = card;
          const cardUrlLowerCase = (cardUrl || '').toLowerCase();
          const cardUrlHasHttp =
            cardUrlLowerCase.includes('http://') ||
            cardUrlLowerCase.includes('https://');
          return cardUrl && cardUrl.trim() !== '' && cardUrlHasHttp;
        })
      : [];
    const validCards =
      cards && cards.length > 0 && cardsWithUrls.length === cards.length;

    const validFooterUrl = footerUrl && footerUrl.split() !== '';
    const validProductSet = productSet && !isNaN(parseInt(productSet, 10));
    const validProductCatalog =
      productCatalog && !isNaN(parseInt(productCatalog, 10));
    const validDescription = description !== undefined;

    let validityArray = [
      validAccountId,
      validAccountName,
      validAdsets,
      validPixel,
      validPageId,
      validPageAccessToken,
      validDisplayUrl
    ];

    switch (adType) {
      case 'Carousel':
        validityArray = validityArray.concat([validCards]);
        break;
      case 'Collection':
        validityArray = validityArray.concat([
          validFooterUrl,
          validDescription,
          validProductSet,
          validProductCatalog
        ]);
        break;
      default:
        validityArray = validityArray.concat([validDestinationUrl]);
        break;
    }

    const invalidFieldBools = validityArray.filter(
      (fieldIsValid) => !fieldIsValid
    );
    adIsReadyToLaunch = invalidFieldBools.length <= 0;
  } catch (error) {
    console.log('Error in returnIsAdReadyToLaunch():', error);
  }

  return adIsReadyToLaunch;
};

// This method is used to launch the ad to Facebook for the selected Adsets. It uses the same launch logic than Package Builder depending on the ad type
export const launchAd = async (
  token,
  formFromState,
  adPrototype,
  adLibraryLaunchCard,
  adLibraryLaunchFieldsComponent
) => {
  const form = formFromState;
  const {
    destinationUrl: formDestinationUrl,
    footerUrl: formFooterUrl,
    productSet: formProductSet,
    cards: formCards,
    selectedCampaigns
  } = form;
  const {
    id: adPrototypeId,
    type: adPrototypeType,
    name: adPrototypeName,
    asset_id: assetId
  } = adPrototype;
  let adsets = [];
  let adsetsData = [];
  let formCardThumbnails = [];

  scrollToBottom();

  form.adsets.forEach((item) => {
    adsets = adsets.concat(item.adsets);
    adsetsData = adsetsData.concat(item.adsetsData);
  });

  const newAdProtoype = adPrototype;

  if (adLibraryLaunchCard) {
    const { state: childState } = adLibraryLaunchCard || {};
    const { currentThumbnail } = childState || {};
    newAdProtoype.thumbnail = currentThumbnail || '';
  }

  if (adLibraryLaunchFieldsComponent) {
    const { state: childState } = adLibraryLaunchFieldsComponent || {};
    const { thumbnails } = childState || {};
    formCardThumbnails = thumbnails || [];
  }

  form.ads = [
    {
      id: adPrototypeId,
      destinationUrl: formDestinationUrl,
      footerUrl: formFooterUrl,
      productSet: formProductSet,
      cards: formCards
    }
  ];

  if (formCardThumbnails && formCardThumbnails.length > 0) {
    form.formCardThumbnails = formCardThumbnails;
  }

  const ad = {
    id: adPrototypeId,
    name: adPrototypeName,
    ad: newAdProtoype
  };
  let launchAdResults = [];

  if (
    adPrototypeType === CAROUSEL ||
    adPrototypeType === CANVAS ||
    adPrototypeType === COLLECTION
  ) {
    launchAdResults = await launchAdToFacebook(
      adPrototypeType,
      ad,
      adsets,
      adsetsData,
      form,
      token
    );
  } else {
    launchAdResults = await Promise.all(
      adsets.map(async (adsetId) => {
        const matchingCampaign = selectedCampaigns
          ? selectedCampaigns.find(
              (campaign) =>
                campaign.adsets &&
                campaign.adsets.find(
                  (innerAdset) => innerAdset.value === adsetId
                )
            )
          : null;

        const willUseConversionDomain = matchingCampaign
          ? [CONVERSIONS, PRODUCT_CATALOG_SALES].includes(
              matchingCampaign.objective
            )
          : false;

        const adToLaunch = { ...ad };
        const adsetData = adsetsData.find((item) => item.value === adsetId);
        const { text: adsetText, promotedObject: adsetPromotedObject } =
          adsetData || {};
        const { product_set_id: productSetId } = adsetPromotedObject || {};
        const type = adPrototypeType === DAA ? assetId : adPrototypeType;
        adToLaunch.name = `${adsetText}_${type}_${adPrototypeName}`;
        let resultAd = {};
        switch (adPrototypeType) {
          case CINEMAGRAPH:
          case VIDEO:
            resultAd = await createVideoAd(
              adToLaunch,
              willUseConversionDomain ? { objective: CONVERSIONS } : null,
              adsetId,
              null,
              token,
              form
            );
            break;
          case STILL:
            // need to get campaign data
            resultAd = await createStillAd(
              adToLaunch,
              willUseConversionDomain ? { objective: CONVERSIONS } : null,
              adsetId,
              null,
              token,
              form
            );
            break;
          case DAA:
            if (adsetData && adsetPromotedObject && productSetId) {
              form.adsets = [
                {
                  id: adsetId,
                  productSet: productSetId
                }
              ];
            } else {
              resultAd = {
                error: {
                  error_user_title: 'Product Set Error',
                  error_user_msg: 'The Adset does not have a Product Set'
                }
              };
              break;
            }

            resultAd = await createDAAAd(
              adToLaunch,
              willUseConversionDomain
                ? { objective: PRODUCT_CATALOG_SALES }
                : null,
              adsetId,
              { id: adsetId },
              form,
              token
            );
            break;
          default:
            break;
        }
        const resultMessage = returnResultMessage(
          resultAd,
          adToLaunch.name,
          adsetText
        );
        const finalResult = {
          resultAd,
          resultMessage
        };
        return Promise.resolve(finalResult);
      })
    );
  }

  let logMessage = '';
  const finalAdResults = launchAdResults.map((resultObj) => {
    const { resultAd, resultMessage } = resultObj;
    logMessage += resultMessage;
    return resultAd;
  });
  return { data: finalAdResults, message: logMessage };
};

const launchAdToFacebook = async (
  type,
  ad,
  adsets,
  adsetsData,
  form,
  token
) => {
  const adPrototypeName = ad.name;
  let launchAdResult = intializeLaunchResult(type, adPrototypeName);
  const resultCreativeOrCanvasData = await returnAdcreativeOrCanvasData(
    type,
    ad,
    form,
    token
  );
  const canAdBeLaunched = returnCanAdBeLaunched(
    type,
    resultCreativeOrCanvasData
  );

  if (canAdBeLaunched) {
    launchAdResult = await Promise.all(
      adsets.map(async (adsetId) => {
        let resultAd = {};
        const adToLaunch = { ...ad };
        const { ad: innerPrototype } = adToLaunch;
        const adsetData = adsetsData.find((item) => item.value === adsetId);
        const { text: adsetText } = adsetData || {};
        adToLaunch.name = `${adsetText}_${type}_${adPrototypeName}`;

        const matchingCampaign = form.selectedCampaigns
          ? form.selectedCampaigns.find(
              (campaign) =>
                campaign.adsets &&
                campaign.adsets.find(
                  (innerAdset) => innerAdset.value === adsetId
                )
            )
          : null;

        const willUseConversionDomain = matchingCampaign
          ? [CONVERSIONS, PRODUCT_CATALOG_SALES].includes(
              matchingCampaign.objective
            )
          : false;
        const newForm = { ...form, willUseConversionDomain };

        switch (type) {
          case CAROUSEL:
            resultAd = await createCarouselAdWIthCreative(
              adToLaunch,
              adsetId,
              newForm,
              resultCreativeOrCanvasData.adCreative,
              token
            );
            break;
          case CANVAS:
            resultAd = await createCanvasAdWithCanvasUrl(
              adToLaunch,
              adsetId,
              newForm,
              resultCreativeOrCanvasData.canvasUrl,
              token
            );
            break;
          case COLLECTION:
            resultAd = !innerPrototype.convertToCinemagraph
              ? await createCollectionAdWithCanvasData(
                  adToLaunch,
                  adsetId,
                  newForm,
                  resultCreativeOrCanvasData.canvasData,
                  token
                )
              : await createVideoAd(
                  adToLaunch,
                  willUseConversionDomain ? { objective: CONVERSIONS } : null,
                  adsetId,
                  null,
                  token,
                  newForm
                );
            break;
          default:
            break;
        }

        if (innerPrototype.convertToCinemagraph) {
          adToLaunch.name = adToLaunch.name.replace(
            'Collection',
            'Cinemagraph'
          );
        }

        const resultMessage = returnResultMessage(
          resultAd,
          adToLaunch.name,
          adsetText
        );
        const finalResult = {
          resultAd,
          resultMessage
        };

        return Promise.resolve(finalResult);
      })
    );
  }

  return Promise.resolve(launchAdResult);
};

const intializeLaunchResult = async (type, name) => {
  const adPrototypeName = name;
  let errorUserMessage = `${adPrototypeName}: `;
  let errorUserTitle = '';
  switch (type) {
    case CANVAS:
      errorUserMessage = errorUserMessage.concat(
        'The canvas could not be generated.\n'
      );
      errorUserTitle = 'Canvas Ad Error';
      break;
    case CAROUSEL:
      errorUserMessage = errorUserMessage.concat(
        'Ad creative generation failed. Check the carousel card thumbnails and other content or remove some cards, and then try again.\n'
      );
      errorUserTitle = 'Carousel Ad Creative Error';
      break;
    case COLLECTION:
      errorUserMessage = errorUserMessage.concat(
        'The canvas for the collection ad could not be generated.\n'
      );
      errorUserTitle = 'Collection Ad Canvas Error';
      break;
    default:
      break;
  }

  const initiLaunchAdResult = [
    {
      resultAd: {
        error: {
          error_user_title: errorUserTitle,
          error_user_msg: errorUserMessage
        }
      },
      resultMessage: errorUserMessage
    }
  ];

  return initiLaunchAdResult;
};

const returnAdcreativeOrCanvasData = async (type, ad, form, token) => {
  const adCreativeOrCanvasResult = {};
  switch (type) {
    case CANVAS:
      adCreativeOrCanvasResult.canvasUrl = await generateAndGetCanvasUrl(
        ad,
        form
      );
      break;
    case CAROUSEL:
      adCreativeOrCanvasResult.adCreative = await createAdCreativeForCarousel(
        ad,
        form,
        token
      );
      break;
    case COLLECTION:
      adCreativeOrCanvasResult.canvasData = await createCanvasForCollectionAd(
        ad,
        form,
        token
      );
      break;
    default:
      break;
  }
  return Promise.resolve(adCreativeOrCanvasResult);
};

const returnCanAdBeLaunched = (type, adCreativeOrCanvasData) => {
  let canAdBeLaunched = false;
  const { canvasUrl, canvasData, adCreative } = adCreativeOrCanvasData || {};
  const { canvasLink } = canvasData || {};
  const { id: resultCreativeId } = adCreative || {};

  switch (type) {
    case CANVAS:
      canAdBeLaunched = canvasUrl && canvasUrl.trim() !== '';
      break;
    case CAROUSEL:
      canAdBeLaunched =
        resultCreativeId && !isNaN(parseInt(resultCreativeId, 10));
      break;
    case COLLECTION:
      canAdBeLaunched = canvasData && canvasLink && canvasLink.trim() !== '';
      break;
    default:
      break;
  }
  return canAdBeLaunched;
};

const returnResultMessage = (resultAd, adName, adsetText) => {
  const { id: resultAdId, error: resultAdError } = resultAd || {};
  const { error_user_title: errorUserTitle, error_user_msg: errorUserMsg } =
    resultAdError || {};
  const resultMessage = resultAdId
    ? `AD: ${adName}: Launched in Adset: ${adsetText}\n`
    : `AD: ${adName}: Failed ${errorUserTitle} ${errorUserMsg}\n`;
  return resultMessage;
};

export const countLaunchStatusesAndReturnStatusObject = (
  adPrototypeId,
  launchAdResultsData
) => {
  const attemptedLaunches = launchAdResultsData.length;
  let successfulLaunches = 0;
  let failedLaunches = 0;
  launchAdResultsData.forEach((launchAdResult) => {
    const { error } = launchAdResult;
    if (error) {
      failedLaunches += 1;
    } else {
      successfulLaunches += 1;
    }
  });

  const launchStatus = {
    adPrototypeId,
    attemptedLaunches,
    successfulLaunches,
    failedLaunches
  };
  return launchStatus;
};

export const scrollToBottom = () => {
  const height = window.innerHeight;
  document
    .querySelector('.App-content')
    .scrollTo({ top: height, left: 0, behavior: 'smooth' });
};

export const returnFailedCollectionAdLaunchStatuses = (
  launchStatuses,
  adPrototypesToLaunch
) => {
  const collectionAdLaunchStatuses = launchStatuses.filter((launchStatus) => {
    const { adPrototypeId } = launchStatus;
    const foundPrototype = adPrototypesToLaunch.find(
      (adPrototype) => adPrototype.id === adPrototypeId
    );
    return foundPrototype && foundPrototype.type === 'Collection';
  });
  const failedCollectionAdStatuses = collectionAdLaunchStatuses.filter(
    (launchStatus) => launchStatus.failedLaunches > 0
  );

  return failedCollectionAdStatuses;
};



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/AdLibrary/AdLibraryLaunchActions.js